const NAME = 'PROGRAM_GENERAL';

// Handling of requests to /programs endpoint
export const REQUEST_PROGRAM_DETAILS = `${NAME}/REQUEST_PROGRAM_DETAILS`;
export const REQUEST_PROGRAM_DETAILS_SUCCESS = `${NAME}/REQUEST_PROGRAM_DETAILS_SUCCESS`;
export const REQUEST_PROGRAM_DETAILS_FAIL = `${NAME}/REQUEST_PROGRAM_DETAILS_FAIL`;

export const RESET_STATE = `${NAME}/RESET_STATE`;
